type DeclarationErrorProps = {
  error?: Error;
};

export default function DeclarationError({ error }: DeclarationErrorProps) {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-6">
        <h2 className="text-2xl font-bold text-red-600 mb-4">
          Invalid Invitation
        </h2>
        <p className="">
          {error instanceof Error
            ? error.message
            : "This invitation link is invalid or has expired. Please contact the application owner for a new invitation."}
        </p>
      </div>
    </div>
  );
}

